"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));
var SnackbarContent_1 = __importDefault(require("@material-ui/core/SnackbarContent"));
var styles_1 = require("@material-ui/core/styles");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var kinsideTokens_1 = require("../kinsideTokens");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        success: {
            backgroundColor: kinsideTokens_1.kinsideTokens["--viridian-0"],
            border: "1px solid " + kinsideTokens_1.kinsideTokens["--viridian-50"],
            color: kinsideTokens_1.kinsideTokens["--viridian-80"],
        },
        error: {
            backgroundColor: kinsideTokens_1.kinsideTokens["--rust-0"],
            border: "1px solid " + kinsideTokens_1.kinsideTokens["--rust-50"],
            color: kinsideTokens_1.kinsideTokens["--rust-80"],
        },
        icon: {
            fontSize: 20,
        },
        iconVariant: {
            opacity: 0.9,
            marginRight: theme.spacing(1),
        },
        message: {
            display: "flex",
            alignItems: "center",
        },
    });
});
var Toast = function (props) {
    var classes = useStyles(props);
    if (!props.open) {
        return null;
    }
    return (react_1.default.createElement(Snackbar_1.default, { anchorOrigin: {
            vertical: "top",
            horizontal: "center",
        }, open: props.open, autoHideDuration: 10000, onClose: props.onClose },
        react_1.default.createElement(SnackbarContent_1.default, { className: props.success ? clsx_1.default(classes.success, classes.success) : clsx_1.default(classes.error, classes.error), id: "snack-notification", "aria-describedby": "client-snackbar", message: react_1.default.createElement("span", { id: "client-snackbar", className: classes.message },
                props.success ? (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircleCheck, className: clsx_1.default(classes.icon, classes.iconVariant) })) : (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircleExclamation, className: clsx_1.default(classes.icon, classes.iconVariant) })),
                props.message), action: [
                react_1.default.createElement(IconButton_1.default, { key: "close", "aria-label": "close", color: "inherit", onClick: props.onClose },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faXmark, className: classes.icon })),
            ] })));
};
exports.Toast = Toast;
